import { render } from "./ChatView.vue?vue&type=template&id=b1a53764"
import script from "./ChatView.vue?vue&type=script&lang=js"
export * from "./ChatView.vue?vue&type=script&lang=js"
script.render = render

export default script